
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Box from 'vux/src/components/box/index.vue'


export default {
name: "Main",
data() {
return {
search_value: "",
search_keyword: [
{
title: "推荐"
},
{
title: "排行榜"
}
],
tabs_selected: "",
tabs: [
{
name: "recommand",
title: "推荐"
},
{
name: "rank",
title: "排行榜"
}
],
results: []
};
},
methods: {
onSearchKeywordClick(title) {
this.search_value = title;
this.onSearchSubmit();
},
onTabItemClick(name) {
this.tabs_selected = name;
this.$router.push(name);
},
resultClick(item) {

this.search_value = item.title;
this.onSearchSubmit();
},
getSearchResult(val) {
this.results = val ? getSearchResult(this.search_value) : [];
},
onSearchSubmit() {
this.$refs.search.setBlur();
this.$vux.toast.show({
type: "text",
position: "top",
text: this.search_value
});
}
},
created () {
if (this.tabs.length > 0) {
let _name = this.$route.name;
let _array = this.tabs.filter(item => item.name == _name);
this.tabs_selected = _array.length > 0 ? _name : this.tabs[0].name;
}
},
components: { Group, CellBox, Search, Tab, TabItem, XButton, Flexbox, FlexboxItem, Box }
};

function getSearchResult(val) {
let rs = [];
for (let i = 0; i < 20; i++) {
rs.push({
title: `${val} result: ${i + 1} `,
other: i
});
}
return rs;
}



// WEBPACK FOOTER //
// ./src/components/MainPage.vue